// agents/rick.js
export function handleRickMessage() {
  showTypingModal("Wubba Lubba Dub Dub!");
  logToConsole("🥒 Rick says: Wubba Lubba Dub Dub!");
}
